import React, { useState, useEffect } from 'react';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import localeUtils from '../../utils/localeUtils';
import { formatDate, parseDate } from 'react-day-picker/moment';
import { useQuery } from '@apollo/react-hooks';
import 'react-day-picker/lib/style.css';
import { Form, Popup, Message, Loader } from 'semantic-ui-react';
import * as Yup from 'yup';

import {
  Container,
  CardContainer,
  ExportButton,
  ExportButtonContainer,
  Title,
  Header,
  Footer,
  Main
} from './styles.js';

import { GET_MALLS_BY_NAME } from '../../services/graphql/queries';

import { postExcelV2 } from '../../services/api_call';


const plateType = [
  { key: 'all', value: 'all', text: 'Todos' },
  { key: 'invalid', value: 'invalid', text: 'Inválido' },
  { key: 'valid', value: 'valid', text: 'Válido' },
  { key: 'black_list', value: 'black_list', text: 'Lista Negra' }
];

// const initialMalls = [{ key: '', value: '', text: 'Todos' }];

const schema = Yup.object().shape({
  beginDatetime: Yup.date().required(),
  finishDatetime: Yup.date().required(),
  email: Yup.string().email().required()
});

export default function ReportLicesePlates() {
  // const [
  //   { mall_id, type, begin_datetime, finish_datetime },
  //   setValues
  // ] = useState({
  //   mall_id: '',
  //   type: '',
  //   begin_datetime: new Date(),
  //   finish_datetime: new Date()
  // });
  const { data } = useQuery(GET_MALLS_BY_NAME);
  const [mallsOptions, setMallsOptions] = useState([]);
  const [countriesOptions, setCountriesOptions] = useState([]);
  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const [{ mall, country, beginDatetime, finishDatetime, type_, email }, setFilter] = useState({
    mall: '2',
    country: '1',
    type_: 'all',
    beginDatetime: new Date(),
    finishDatetime: new Date(),
    email: ''
  });
  const [{ finishDatetimeError, beginDatetimeError, emailError }, setDatesError] = useState(
    {
      finishDatetimeError: false,
      beginDatetimeError: false,
      emailError: false
    }
  );

  const modifiers = { start: beginDatetime, end: finishDatetime };


  useEffect(() => {
    if (data) {
      if (data.getMalls) {
        const malls = data.getMalls.map(mall => ({
          key: mall.id,
          text: `${mall.name} - ${mall.code}`,
          value: mall.id
        })).filter((data, index) => index !== 0);

        setMallsOptions(malls);
      }
      if (data.getCountries) {
        const countries = data.getCountries.map(country => ({
          key: country.id,
          text: country.name,
          value: country.id
        }));
        setCountriesOptions(countries);
      }
    }
  }, [data]);

  async function handleFilterOnClick() {
    try {
      setDatesError({
        finish_datetimeError: false,
        begin_datetimeError: false,
        email_error: false
      });

      await schema.validate(
        { finishDatetime, beginDatetime, email },
        { abortEarly: false }
      );

      // setValues(prevState => ({
      //   ...prevState,
      //   mall_id: mall,
      //   begin_datetime: beginDatetime,
      //   finish_datetime: finishDatetime,
      //   type: type_
      // }));

      const params = {
        mall_id: mall,
        country_id: country,
        begin_datetime: beginDatetime,
        finish_datetime: finishDatetime,
        type: type_,
        email: email,
        timezone: 'America/Santiago'
      };

      setLoading(true);
      
      postExcelV2(params).then(response => {
        setLoading(false);
        if (response.ok) {
          setSuccess(response.statusText)
          setError(false);
        } else {
          setError(response)
          setSuccess(false);
        }
      });

    } catch (err) {
      // setDownloadExcel(false);
      err.inner &&
        err.inner.map(error =>
          setDatesError(prevState => ({
            ...prevState,
            [`${error.path}Error`]: true
          }))
        );
    }
  }

  return (
    <Container>
      <CardContainer>
        <Header>
          <Title>Reportes Patentes</Title>
        </Header>
        <Main>
          <Form>
            <Form.Group>
              <Popup
                mouseEnterDelay={500}
                mouseLeaveDelay={200}
                content="Fecha de inicio para la búsqueda"
                trigger={
                  <span style={{ margin: '0 9px' }}>
                    <Form.Field
                      error={beginDatetimeError}
                      label="Fecha de Inicio *"
                      control={DayPickerInput}
                      value={beginDatetime}
                      format="DD/MM/YYYY"
                      placeholder="DD/MM/YYYY"
                      formatDate={formatDate}
                      parseDate={parseDate}
                      onDayChange={day =>
                        setFilter(prevState => ({
                          ...prevState,
                          beginDatetime: day
                        }))
                      }
                      dayPickerProps={{
                        localeUtils: localeUtils, locale: 'es',
                        selectedDays: [
                          beginDatetime,
                          { beginDatetime, finishDatetime }
                        ],
                        modifiers,
                        disabledDays: {
                          // before: new Date(finishDatetime.getFullYear(), finishDatetime.getMonth() -1, finishDatetime.getDate()),
                          after: finishDatetime
                        },
                        numberOfMonths: 1
                      }}
                    />
                  </span>
                }
              />
              <Popup
                mouseEnterDelay={500}
                mouseLeaveDelay={200}
                content="Fecha de fin para la búsqueda"
                trigger={
                  <span style={{ margin: '0 9px' }}>
                    <Form.Field
                      error={finishDatetimeError}
                      label="Fecha de Termino *"
                      control={DayPickerInput}
                      value={finishDatetime}
                      format="DD/MM/YYYY"
                      placeholder="DD/MM/YYYY"
                      formatDate={formatDate}
                      parseDate={parseDate}
                      onDayChange={day =>
                        setFilter(prevState => ({
                          ...prevState,
                          beginDatetime: day < beginDatetime ? day : beginDatetime,
                          finishDatetime: day
                        }))
                      }
                      dayPickerProps={{
                        localeUtils: localeUtils, locale: 'es',
                        selectedDays: [
                          beginDatetime,
                          { beginDatetime, finishDatetime }
                        ],
                        modifiers,
                        disabledDays: {
                          after: new Date()
                        },
                        numberOfMonths: 1
                      }}
                    />
                  </span>
                }
              />
            </Form.Group>
            <Form.Group>
              <Form.Select
                label="Tipo"
                placeholder="Todos"
                options={plateType}
                width={6}
                value={type_}
                onChange={(e, { value }) =>
                  setFilter(prevState => ({
                    ...prevState,
                    type_: value
                  }))
                }
              />

              <Form.Select
                label="Centro Comercial"
                placeholder="Todos"
                options={[...mallsOptions]}
                width={6}
                value={mall}
                onChange={(e, { value }) =>
                  setFilter(prevState => ({
                    ...prevState,
                    mall: value
                  }))
                }
              />
              <Form.Select
                label="País"
                placeholder="Seleccione País"
                options={countriesOptions}
                width={6}
                value={country}
                onChange={(e, { value }) =>
                  setFilter(prevState => ({
                    ...prevState,
                    country: value
                  }))
                }
              />
            </Form.Group>
            <Form.Group>
              <Form.Input
                  error={emailError}
                  label="Correo Electrónico *"
                  placeholder="Email"
                  width={5}
                  value={email}
                  onChange={(e, { value }) =>
                    setFilter(prevState => ({
                      ...prevState,
                      email: value
                    }))
                  }
                />
            </Form.Group>
          </Form>
        </Main>
        <Footer>
          <ExportButtonContainer>
            <ExportButton onClick={handleFilterOnClick}>Exportar a Excel</ExportButton>
          </ExportButtonContainer>
        </Footer>

      </CardContainer>
      {
        loading && <Loader active inline="centered" />
      }
      {
        error && <Message error header={error.statusText} content={error['data'] ? error['data']['message'] : error.statusText} />
      }
      {
        success && <Message success header="OK" content={success} />
      }
      
    </Container>
  );
}
